import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });
export const fileUrl = (id, kind = "file") => `${API}/files/${id}/${kind}`;

export const fmtViews = (n = 0) =>
  n >= 1e6 ? `${(n / 1e6).toFixed(1)}M` : n >= 1e3 ? `${(n / 1e3).toFixed(1)}k` : `${n}`;

export const fmtDuration = (s = 0) => {
  if (!s) return "";
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60).toString().padStart(2, "0");
  return m >= 60 ? `${Math.floor(m / 60)}:${(m % 60).toString().padStart(2, "0")}:${sec}` : `${m}:${sec}`;
};

export const asList = (res) => (Array.isArray(res?.data) ? res.data : []);

export const MOOD = ["/img/m1.jpg", "/img/m2.jpg", "/img/m3.jpg", "/img/m4.jpg", "/img/lines.jpg", "/img/silk.jpg"];
